import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";

export const getClinician = async () => {
    const res = await api.get(`/Clinician`);

    return {
        ...res.data,
        credentially_OK:
            res.data.credentially_OK === 1 || res.data.credentially_OK === 2,
    };
};

export const useClinician = () => {
    return useQuery({
        queryKey: ["clinician"],
        queryFn: getClinician,
        retry: 3,
        staleTime: Infinity,
    });
};
